import Component from '@glimmer/component';

import { action } from '@ember/object';

export default class ListFiltersComponent extends Component {
  @action
  setReload(variable, value, variable1 = null, value1 = null, type = null) {
    // {{on}} appends the DOM event as last arg; keep optional params clean
    if (variable1 instanceof Event) {
      variable1 = null;
    }
    if (type instanceof Event) {
      type = null;
    }

    this.args.setReload(variable, value, variable1, value1, type);
  }
}
